import React from 'react'

const landingImages = require.context('../../assets/images', true)


export const SuccessfulCaseCard = ({text, name, image}) => {
  return (
    <div className='row justify-content-center align-items-center mt-4 mt-lg-5 SuccessfulCases__mb-100px'>
        <div className='col-7 col-sm-4 col-md-4 col-lg-4 col-xl-3 mb-5 mb-md-auto'>
        {/* <div className='col-7 col-sm-5 col-md-4 col-lg-3 col-xl-2'> */}
            <img alt={name + 'picture'} src={landingImages(`./${image}`)} className='SuccessfulCases__image' width="196" height="196" />                         

        </div>
        <div className='col-10 col-sm-8 col-md-8 col-lg-8 text-start '>
            <div className='SuccessfulCases__text'>

            {'"'+text+'"'}
            </div>
            <div className='mt-3 SuccessfulCases__name'>
            {'- '+name}
            </div>
        </div>
    </div>
  )
}
